import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PartnershipLogo from 'Common/PartnershipLogo';

import styles from 'components/CarLeaseIndicator.scss';

/**
 * <CarLeaseIndicator /> component.
 * @return {class} returns CarLeaseIndicator instance
 */
class CarLeaseIndicator extends Component {
  /**
   * @param {object} props - props passed
   */
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   *
   */
  static propTypes = {
    onRoadPrice: PropTypes.number,
    expectedAnnualMileage: PropTypes.number,
    initialPayment: PropTypes.number,
    monthlyPayment: PropTypes.number,
    termMonths: PropTypes.number,
    depositMonths: PropTypes.number,
    derivative: PropTypes.string,
    indicatorType: PropTypes.string,
    isMobile: PropTypes.bool
  };

  /**
   * Renders <CarLeaseIndicator /> component.
   *
   * @return {JSX} - renders a Price Indicator Data.
   */
  render() {
    const {
      expectedAnnualMileage,
      initialPayment,
      monthlyPayment,
      termMonths,
      depositMonths,
      derivative,
      indicatorType,
      isMobile
    } = this.props;

    return (
      <div className={styles.container}>
        <h4>About our price indicator</h4>

        <h4>
          What Car? indicative {indicatorType} lease example{' '}
          <span className={styles.disclaimer}>(subject to status)</span>
        </h4>
        <h4>{derivative}</h4>

        <div className={styles.tableContainer}>
          <table className={styles.priceTable}>
            <tbody>
              {expectedAnnualMileage && (
                <tr>
                  <td>Expected annual mileage</td>
                  <td>{expectedAnnualMileage}</td>
                </tr>
              )}
              {termMonths && (
                <tr>
                  <td>Term months</td>
                  <td>{termMonths}</td>
                </tr>
              )}
              {depositMonths && (
                <tr>
                  <td>Deposit months</td>
                  <td>{depositMonths}</td>
                </tr>
              )}
              {monthlyPayment && (
                <tr>
                  <td>Monthly payment</td>
                  <td>{monthlyPayment.toLocaleString()}</td>
                </tr>
              )}
              {initialPayment && (
                <tr>
                  <td>Initial payment</td>
                  <td>£{initialPayment.toLocaleString()}</td>
                </tr>
              )}
            </tbody>
          </table>
          <div className={styles.textContainer}>
            <h4>Step-by-step</h4>
            <p>
              Leasing works a bit like a long-term rental. You drive it, but you
              don’t own it.
            </p>
            <ul>
              <li>
                Choose your car, pick your terms and apply for lease credit
                online
              </li>
              <li>Pay monthly rental payments for your chosen term length</li>
              <li>Drive it, enjoy it, then give it back at the end</li>
            </ul>

            <h4>What you get</h4>
            <p>When you lease with Autotrader you get all of this:</p>
            <ul>
              <li>Full manufacturer’s warranty</li>
              <li>Road tax and roadside assistance included</li>
              <li>Free returns within 30 days*</li>
            </ul>
          </div>
        </div>
        <small>
          Excess mileage charges and return conditions apply. Subject to
          availability and credit status. 18+ T&Cs apply.
        </small>
        <div className={styles.logoWrapper}>
          <PartnershipLogo extendStyle={isMobile ? styles.partnerLogo : ''} />
        </div>
      </div>
    );
  }
}

export default CarLeaseIndicator;



// WEBPACK FOOTER //
// ./src/Common/CarLeaseIndicator/index.js